import { render, staticRenderFns } from "./SalesLeads.vue?vue&type=template&id=fbba3446&scoped=true&"
import script from "./SalesLeads.vue?vue&type=script&lang=js&"
export * from "./SalesLeads.vue?vue&type=script&lang=js&"
import style0 from "./SalesLeads.vue?vue&type=style&index=0&id=fbba3446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbba3446",
  null
  
)

export default component.exports